import React, { useState } from 'react';
import { BsCheckLg, BsXLg } from 'react-icons/bs';
import { ROUTE_AUTH_STATUS, formatMoney } from '../../services/salesRoutesService';
import styles from '../../css/SalesRoutes.module.css';

const CUSTOMER_STEP = 50;

const REVIEW_BADGES = {
    [ROUTE_AUTH_STATUS.pending]: { label: 'Pending to review', className: styles.badgePending },
    [ROUTE_AUTH_STATUS.authorized]: { label: 'Authorized', className: styles.badgeActive },
    [ROUTE_AUTH_STATUS.rejected]: { label: 'Rejected', className: styles.badgeRejected },
};

export const formatRouteDate = (iso) => {
    const date = new Date(iso);
    return !iso || Number.isNaN(date.getTime())
        ? ''
        : date.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
};

export const customerCount = (n) => `${n.toLocaleString()} ${n === 1 ? 'customer' : 'customers'}`;

export function ReviewBadge({ status }) {
    const badge = REVIEW_BADGES[status] || REVIEW_BADGES[ROUTE_AUTH_STATUS.pending];
    return <span className={`${styles.badge} ${badge.className}`}>{badge.label}</span>;
}

export const reviewSummary = (route) => {
    const verb = route.authStatus === ROUTE_AUTH_STATUS.rejected ? 'Rejected' : 'Authorized';
    return [verb, route.reviewedBy && `by ${route.reviewedBy}`, formatRouteDate(route.reviewedAt) && `on ${formatRouteDate(route.reviewedAt)}`]
        .filter(Boolean)
        .join(' ');
};

// Quién creó la ruta y, si ya se revisó, quién decidió y con qué comentario.
export function RouteReviewMeta({ route }) {
    const created = ['Created', route.createdBy && `by ${route.createdBy}`, formatRouteDate(route.createdAt) && `on ${formatRouteDate(route.createdAt)}`]
        .filter(Boolean)
        .join(' ');
    return (
        <>
            {created !== 'Created' && <p className={styles.reviewMeta}>{created}</p>}
            {route.authStatus !== ROUTE_AUTH_STATUS.pending && <p className={styles.reviewMeta}>{reviewSummary(route)}</p>}
            {route.authStatus === ROUTE_AUTH_STATUS.rejected && route.rejectionComment && <p className={styles.reviewComment}>{route.rejectionComment}</p>}
        </>
    );
}

// Solo ofrece la decisión que cambia algo: una ruta autorizada se puede rechazar y viceversa.
export function ReviewActions({ route, busy, onAuthorize, onReject }) {
    return (
        <div className={styles.reviewActions}>
            {route.authStatus !== ROUTE_AUTH_STATUS.authorized && (
                <button type="button" className={styles.btnApprove} disabled={busy} onClick={() => onAuthorize(route)}>
                    <BsCheckLg aria-hidden="true" /> Authorize
                </button>
            )}
            {route.authStatus !== ROUTE_AUTH_STATUS.rejected && (
                <button type="button" className={styles.btnReject} disabled={busy} onClick={() => onReject(route)}>
                    <BsXLg aria-hidden="true" /> Reject
                </button>
            )}
        </div>
    );
}

// Lista desplegable de los clientes de la ruta, para revisarlos sin entrar a editarla.
export function RouteCustomersToggle({ route, goals }) {
    const [open, setOpen] = useState(false);
    const [limit, setLimit] = useState(CUSTOMER_STEP);
    return (
        <div>
            <button type="button" className={styles.linkBtn} aria-expanded={open} onClick={() => setOpen(!open)}>
                {open ? 'Hide customers' : `View customers (${route.customers.length.toLocaleString()})`}
            </button>
            {open && (
                <>
                    <ul className={`${styles.rows} ${styles.routeDetailsPanel}`}>
                        {route.customers.slice(0, limit).map((c) => (
                            <li key={c.customerNo} className={styles.detailRow}>
                                <span className={styles.rowName}>{c.name}</span>
                                <span className={styles.rowMeta}>{[c.customerNo, [c.city, c.state].filter(Boolean).join(', ')].filter(Boolean).join(' · ')}</span>
                                {goals.get(c.customerNo) && <span className={styles.goalChip}>Goal {formatMoney(goals.get(c.customerNo))}</span>}
                            </li>
                        ))}
                    </ul>
                    {route.customers.length > limit && (
                        <button type="button" className={`${styles.btnSecondary} ${styles.showMore}`} onClick={() => setLimit(limit + CUSTOMER_STEP)}>
                            Show more ({(route.customers.length - limit).toLocaleString()} left)
                        </button>
                    )}
                </>
            )}
        </div>
    );
}
